// extracted by mini-css-extract-plugin
export default {"header":"TrojanHeader_header__WA1SD"};